var map = {
	"./Proiect1.jpg": 5101,
	"./Proiect2.jpg": 9170,
	"./Proiect3.jpg": 879,
	"./Proiect4.jpg": 9444,
	"./Proiect5.jpg": 3777,
	"./Proiect6.jpg": 6022,
	"./Proiect7.jpg": 9155,
	"./Proiect8.jpg": 4696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3201;